import moment from "moment";

const log = (val) => {
    if (process.env.REACT_APP_DEV_MODE === `true`)
        console.log(val);
};

const autoEscapeRegExp = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

const formatMobile = (mobile) => {
    let phoneNumber = mobile.replace(/-/g, '');

    const isValidMobile = /^(601|01|1)[0|1|2|3|4|6|7|8|9][0-9]{7,8}$/.test(phoneNumber);

    if (isValidMobile) {

        if (phoneNumber.startsWith('0')) {
            phoneNumber = '6' + phoneNumber.substring(0);
        }

        if (phoneNumber.startsWith('1')) {
            phoneNumber = '60' + phoneNumber.substring(0)
        }
    }

    return phoneNumber
}

const timezoneConvert = (date) => {
    const newDate = new Date(date).toLocaleString("en-Us", {
        timeZone: "Asia/Kuala_Lumpur",
    });
    return newDate;
};

const formatDateYYYYMMDD = (date) => {
    return date?.toISOString().split('T')[0] // 2024-03-07
}

const formatDateDMY = (date) => {
    let formatDate = moment(date).format("DD-MM-YYYY");
    return formatDate;
};

const formatDateMY = (date) => {
    let formatDate = moment(date).format("MM-YYYY");
    return formatDate;
};

const formatDateDMYAM = (date) => {
    const formattedTime = moment(date).format('DD-MM-YYYY h:mmA');
    return formattedTime;
}

const formatDateTimeMY = (datetime) => {
    const datetimeValue = new Date(datetime);
    //return datetimeValue.toLocaleString();

    let hours = datetimeValue.getHours();
    let minutes = datetimeValue.getMinutes();
    const apm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    return `${datetimeValue.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })} ${hours}:${minutes}${apm}`;
};

const formatYearMonthObj = ({ year, month }) => {
    return `${String(month).padStart(2, '0')}-${year}`
}

const formatMilisecondToDate = (milliseconds) => {
    if (!milliseconds) return '';
    const date = new Date(milliseconds);
    return date.toLocaleString('en-GB')
}

const dateDiffInMins = (startDate, endDate) => {
    const now = new Date();
    const startD = startDate ? new Date(startDate) : now;
    const endD = endDate ? new Date(endDate) : now;
    const diff = endD.getTime() - startD.getTime();

    return (diff / 60000);
}

const parseYYYYMMDD = (value) => {
    if (value) {
        const str = value.toString();

        return new Date(
            str.slice(0, 4),
            str.slice(4, 6) - 1,
            str.slice(6, 8)
        );
    }
};

const getDueDate = (date, days = 6) => {
    const due = new Date(date)
    due.setDate(due.getDate() + days)
    return due;
}

const formatFullAddress = (...components) => {
    // Helper function to remove trailing commas from a string
    const removeTrailingCommas = (str) => typeof str === 'string' ? str.replace(/,\s*$/, '') : '';

    // Use array destructuring and map to format each component in a single line
    const [
        formattedLine1,
        formattedLine2,
        formattedPostcode,
        formattedCity,
        formattedArea,
        formattedState,
        formattedCountry
    ] = components.map(removeTrailingCommas);

    // Filter out falsy values and join the non-empty components with commas
    const formattedAddress = [formattedLine1, formattedLine2, formattedPostcode, formattedCity, formattedArea, formattedState, formattedCountry]
        .filter(Boolean)
        .join(', ');

    return formattedAddress;
};

const thousandSeparator = (val) => {
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const numberFormatter = (val, decimal) => {
    const negative = val < 0
    val = String(val)
    if (negative) val = val.replace(/-/g, "")
    let newVal = "";

    if (decimal > 0) {
        newVal = val.replace(/[^0-9.]/g, ""); //allow decimal

        if (val.indexOf(".") === 0) { //auto add a zero if dot is typed first
            newVal = val.replace(/\./g, "0.")
        }
        if (newVal.charAt(0) === "0" && newVal.charAt(1) !== ".") {
            return newVal = "0" //prevent typing number start with zero except decimal
        }

        const dotIdx = newVal.indexOf(".")

        if (dotIdx >= 0) {
            newVal = (thousandSeparator(newVal.substring(0, dotIdx)) //numbers before dot
                + newVal.substring(dotIdx, dotIdx + 1) //dot
                + newVal.substring(dotIdx + 1, dotIdx + 1 + decimal).replace(/\./g, "")) //decimal numbers after dot (prevent typing multiple dots)
        }
        else newVal = thousandSeparator(newVal)
        // newVal = (dotIdx >= 0) ?
        //     (thousandSeparator(newVal.substring(0, dotIdx)) + newVal.substring(dotIdx, dotIdx + 1)
        //         + newVal.substring(dotIdx + 1, dotIdx + 1 + decimal).replace(/\./g, ""))
        //     : thousandSeparator(newVal)
    }
    else {
        newVal = thousandSeparator(val.replace(/[^0-9]/g, "")) //no decimal allowed
    }

    return negative ? "-" + newVal : newVal
}

const formatCurrency = (val) => {
    return val?.toFixed(2)
}

const Dollar = (amount) => {
    var words = new Array();
    words[0] = "zero";
    words[1] = "One";
    words[2] = "Two";
    words[3] = "Three";
    words[4] = "Four";
    words[5] = "Five";
    words[6] = "Six";
    words[7] = "Seven";
    words[8] = "Eight";
    words[9] = "Nine";
    words[10] = "Ten";
    words[11] = "Eleven";
    words[12] = "Twelve";
    words[13] = "Thirteen";
    words[14] = "Fourteen";
    words[15] = "Fifteen";
    words[16] = "Sixteen";
    words[17] = "Seventeen";
    words[18] = "Eighteen";
    words[19] = "Nineteen";
    words[20] = "Twenty";
    words[30] = "Thirty";
    words[40] = "Forty";
    words[50] = "Fifty";
    words[60] = "Sixty";
    words[70] = "Seventy";
    words[80] = "Eighty";
    words[90] = "Ninety";
    words[100] = "One Hundred";
    words[200] = "Two Hundred";
    words[300] = "Three Hundred";
    words[400] = "Four Hundred";
    words[500] = "Five Hundred";
    words[600] = "Six Hundred";
    words[700] = "Seven Hundred";
    words[800] = "Eight Hundred";
    words[900] = "Nine Hundred";
    amount = amount.toString();
    var atemp = amount.split(".");
    var number = atemp[0].split(",").join("");
    var n_length = number.length;
    var words_string = "";
    if (n_length <= 11) {
        var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        var received_n_array = new Array();
        for (var i = 0; i < n_length; i++) {
            received_n_array[i] = number.substr(i, 1);
        }
        for (var i = 11 - n_length, j = 0; i < 11; i++, j++) {
            n_array[i] = received_n_array[j];
        }
        for (var i = 0, j = 1; i < 11; i++, j++) {
            if (i == 0 || i == 3 || i == 6 || i == 9) {
                if (n_array[i] == 1) {
                    n_array[j] = 10 + parseInt(n_array[j]);
                    n_array[i] = 0;
                }
            }
        }
        var value = "";
        for (var i = 0; i < 11; i++) {
            if (i == 0 || i == 3 || i == 6 || i == 9) {
                value = n_array[i] * 10;
            } else if (i == 2 || i == 5 || i == 8) {
                value = n_array[i] * 100;
            } else {
                value = n_array[i];
            }

            if (value != 0) {
                words_string += words[value] + " ";
            }
            if (i == 1 && value != 0 && n_array[i - 1] > 0) {
                words_string += "Billion ";
            } else if (i == 1 && value != 0) {
                words_string += "Biillion ";
            }
            if (i == 4 && value == 0 && (n_array[i - 1] > 0 || n_array[i - 2] > 0)) {
                words_string += "Million ";
            } else if (i == 4 && value != 0) {
                words_string += "Million ";
            }
            if (i == 7 && value == 0 && (n_array[i - 1] > 0 || n_array[i - 2] > 0)) {
                words_string += "Thousand ";
            } else if (i == 7 && value != 0) {
                words_string += "Thousand ";
            }
        }
        words_string = words_string.split(" ").join(" ");
    }
    return words_string;
};

const numericConverter = (n) => {
    const negative = n < 0
    if (!n) return null;
    var op = "";
    var cur = null;
    var frac = "Cent";
    let numStr = n.toString()
    if (negative) numStr = numStr.replace(/-/g, "")
    const nums = numStr.split(".");
    var whole = Dollar(nums[0]);
    if (nums[1] == null) nums[1] = 0;
    if (nums[1].length == 1) nums[1] = nums[1] + "0";
    if (nums[1].length > 2) {
        nums[1] = nums[1].substring(2, nums[1].length - 1);
    }
    if (nums.length == 2) {
        if (nums[0] <= 12) {
            nums[0] = nums[0] * 10;
        } else {
            nums[0] = nums[0];
        }
        var fraction = Dollar(nums[1]);
        if (whole == "" && fraction == "") {
            op = "Zero only";
        }
        if (whole == "" && fraction != "") {
            op = fraction + frac + " only";
        }
        if (whole != "" && fraction == "") {
            op = whole + "only";
        }
        if (whole != "" && fraction != "") {
            op = whole + "and " + fraction + " Only";
        }
        //   console.log(op);
        return negative ? "NEGATIVE " + op.toUpperCase() : op.toUpperCase();
    }
};

const downloadFile = (data, filename) => {
    // Create a download link using the response data
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    // Clean up the URL object and remove the download link
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
}

const capitalizeFirstLetter = (text) => {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

const generateRandomString = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

/**
 * calculate sum of array or array of object with specified field name
 * @param {Array} arr - array to calculate
 * @param {string} field - optional, the field name of the obj to sum up
 */
const getSumOf = (arr, field) => {
    const total = arr.reduce((acc, e) => {
        const num = field ? e[field] : e;
        return acc + Number(num);
    }, 0)

    return total;
}

/**
 * Concat an array of strings into 1 sentence using comma (,) with n characters,
 * remaining strings concat as '... n more'
 * @param {Array} arr - array of strings or object with 'options.objField' to concat
 * @param {Number} limit - maximum characters of the string, default = 50, if limit = 0 means unlimited
 * @param {object} options
 * @param {string} options.objField - for array of objects, the objField name for string concat
 */
const concatStrWithLimit = (arr, { limit = 50, objField } = {}) => {
    if (!arr || arr.length === 0) return '';

    // Handle the first item separately to ensure it is always included
    let firstItem = arr[0];
    if (objField) firstItem = arr[0]?.[objField];
    let concatenatedString = firstItem || '';
    let remainingCount = 0;

    // Start loop from the second item (index 1)
    for (let i = 1; i < arr.length; i += 1) {
        let strToConcat = arr[i];
        if (objField) strToConcat = arr[i]?.[objField];
        const stringWithComma = `, ${strToConcat}`;

        // Check if adding the next string exceeds the limit
        if (limit > 0 && (concatenatedString + stringWithComma).length > limit) {
            remainingCount = arr.length - i;
            break;
        }

        concatenatedString += stringWithComma;
    }

    if (remainingCount > 0) {
        concatenatedString += ` + ${remainingCount} more item(s)`;
    }

    return concatenatedString;
}

const getExcludedCond = (userSlice) => {
    const isOwner = userSlice?.role === 'Owner';
    const ownerCreatedDate = isOwner ? userSlice?.created : userSlice?.ownerCreated;
    if (!ownerCreatedDate) return true; // any user without ownerCreated date, auto excluded, eg: Admin, and all other user roles not under an owner

    const date = process.env.REACT_APP_DEPLOYMENT_DATE
    const deploymentDate = parseYYYYMMDD(date)
    deploymentDate?.setHours(0, 0, 0, 0)

    const createdDate = new Date(ownerCreatedDate)
    createdDate?.setHours(0, 0, 0, 0)

    const excludedCond = deploymentDate ? createdDate < deploymentDate : false
    return excludedCond;
}

const formatString = (text) => {
    if (!text) return '';
    return String(text).toLowerCase().replace(/[^a-z0-9]/g, '').replace(/\s+/g, '');
}

export default {
    log,
    autoEscapeRegExp,
    formatMobile,
    dateDiffInMins,
    timezoneConvert,
    formatDateYYYYMMDD,
    formatDateDMY,
    formatDateMY,
    formatDateDMYAM,
    formatDateTimeMY,
    formatYearMonthObj,
    formatMilisecondToDate,
    parseYYYYMMDD,
    getDueDate,
    formatFullAddress,
    thousandSeparator,
    numberFormatter,
    formatCurrency,
    numericConverter,
    downloadFile,
    capitalizeFirstLetter,
    generateRandomString,
    getSumOf,
    concatStrWithLimit,
    getExcludedCond,
    formatString
}